module.exports = __webpack_public_path__ + "static/img/resourceLinks.3ea09da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/resourceLinks.jpg
// module id = 6Jvg
// module chunks = 0